import React from 'react';

const SearchResult = props => {
  return (
    <div className="search-result">
      <p className="type">{props.type}</p>
      <div
        className="search-result-title"
        dangerouslySetInnerHTML={{ __html: props.nodeLink }}
      />
      <p className="body">{props.resultText}</p>
    </div>
  );
};

export default SearchResult;
